import instance from "../config/axios";
import { ErrorHandler } from "../config/ErrorHandler";

export const get = async (endPoint, params) => {
    try {
        const result = await instance.get(endPoint, { params: params });
        if (result.status === 200) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};

export const post = async (endPoint, data) => {
    try {
        const result = await instance.post(endPoint, data);
        if (result.status === 200 || result.status === 201) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};

export const put = async (endPoint, data) => {
    try {
        const result = await instance.put(endPoint, data);
        if (result.status === 200) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};

export const deleted = async (endPoint, params) => {
    try {
        const result = await instance.delete(endPoint, { params: params });
        if (result.status === 200) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};